import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/home-page/components/StickyMobileBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/app/latest-result/ClientGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dreamz.academy/httpdocs/src/components/ui/AppImage.tsx");
